import { httpClient } from '@/lib/api';
import { setCurrency } from '@/lib/currency';
export interface PlatformSettings {
  currency: string;
  version: number;
  updatedAt: string | null;
}
export const settingsKey = ['platform-settings'] as const;
export const settingsApi = {
  read: async (): Promise<PlatformSettings> => {
    const settings = await httpClient.get<PlatformSettings>('/settings');
    setCurrency(settings.currency);
    return settings;
  },
  save: async (
    input: Pick<PlatformSettings, 'currency' | 'version'>,
  ): Promise<PlatformSettings> => {
    const settings = await httpClient.put<PlatformSettings>('/settings', input);
    setCurrency(settings.currency);
    return settings;
  },
};
